import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgShield = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.015 2a.75.75 0 0 1 .587.302c1.732 2.33 4.641 3.503 8.602 3.257a.75.75 0 0 1 .796.749v3.958c-.006 2.449-.81 4.834-2.3 6.844-1.488 2.01-3.59 3.551-6.026 4.433h-.002l-.918.33a2.3 2.3 0 0 1-1.508 0l-.009-.002-.91-.328C7.89 20.66 5.787 19.12 4.298 17.11S2.006 12.715 2 10.266V6.308a.75.75 0 0 1 .848-.744 9.8 9.8 0 0 0 4.787-.562c1.51-.58 2.815-1.524 3.781-2.723A.75.75 0 0 1 12.014 2m-.035 1.904a10.6 10.6 0 0 1-3.806 2.498c-1.483.57-3.081.817-4.674.729v3.132c.005 2.12.7 4.194 2.005 5.955 1.305 1.76 3.16 3.128 5.33 3.914h.002l.903.325a.8.8 0 0 0 .52 0l.903-.325c2.171-.786 4.028-2.153 5.332-3.915 1.304-1.76 2-3.835 2.005-5.954V7.088c-3.572.063-6.519-.99-8.52-3.184"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgShield;
